
import { ConsultRepository } from "../../../domain/repositories/consult.repository";
import { GetAttentionConsecutiveUseCase } from "../../../domain/usecases/consult/get-attention-consecutive.usecase";
import { GetAttentionReportByDateUseCase } from "../../../domain/usecases/consult/get-attention-report-by-date.usecase";
import { GetDetalleAtencionReportUseCase } from "../../../domain/usecases/consult/get-detalle-atencion-report.usecase";
import { GetStepServiceUseCase } from "../../../domain/usecases/consult/get-step-service.usecase";
import { GetTypeConsultUseCase } from "../../../domain/usecases/consult/get-type-consult-usecase";
import { GetTypeDocumentsUseCase } from "../../../domain/usecases/consult/get-type-documents-usecase";
import { InsertAttentionUseCase } from "../../../domain/usecases/consult/insert-attention-usecase";
import { InsertBackgroundUseCase } from "../../../domain/usecases/consult/insert-background-usecase";
import { InsertConfirmationUseCase } from "../../../domain/usecases/consult/insert-confirmation-usecase";
import { InsertConsultUseCase } from "../../../domain/usecases/consult/insert-consult-usecase";
import { InsertDataInitialUseCase } from "../../../domain/usecases/consult/insert-data-initial.usecase";
import { InsertDiagnosticUseCase } from "../../../domain/usecases/consult/insert-diagnostic-usecase";
import { InsertDocumentsUseCase } from "../../../domain/usecases/consult/insert-documents-usecase";
import { InsertGeneralUseCase } from "../../../domain/usecases/consult/insert-general-usecase";
import { InsertOthersOptometryUseCase } from "../../../domain/usecases/consult/insert-others-usecase";
import { InsertRevisionUseCase } from "../../../domain/usecases/consult/insert-revision.usecase";
import { InsertVitalSignsUseCase } from "../../../domain/usecases/consult/insert-vital-signs-usecase";
import { UpdateAttentionUseCase } from "../../../domain/usecases/consult/update-attention-usecase";
import { UpdateBackgroundUseCase } from "../../../domain/usecases/consult/update-background-usecase";
import { UpdateConsultUseCase } from "../../../domain/usecases/consult/update-consult-usecase";
import { UpdateDataInitialUseCase } from "../../../domain/usecases/consult/update-data-initial.usecase";
import { UpdateDiagnosticUseCase } from "../../../domain/usecases/consult/update-diagnostic-usecase";
import { UpdateDocumentsUseCase } from "../../../domain/usecases/consult/update-documents-usecase";
import { UpdateGeneralUseCase } from "../../../domain/usecases/consult/update-general-usecase";
import { UpdateOthersUseCase } from "../../../domain/usecases/consult/update-others-usecase";
import { UpdateRevisionUseCase } from "../../../domain/usecases/consult/update-revision.usecase";
import { UpdateVitalSignsUseCase } from "../../../domain/usecases/consult/update-vital-signs-usecase";
import { UpdateDevelopmentUseCase } from '../../../domain/usecases/consult/update-development-usecase';
import { InsertDevelopmentUseCase } from "../../../domain/usecases/consult/insert-development-usecase";
import { CancelAttentionUseCase } from "../../../domain/usecases/consult/cancel-attention.usecase";
import { DeleteDocumentUseCase } from "../../../domain/usecases/consult/delete-document.usecase";
import { GetDocumentsByClientUseCase } from '../../../domain/usecases/consult/get-documents-by-client-usecase';
import { GetTypeDiagnosticUseCase } from "../../../domain/usecases/consult/get-type-diagnostic-usecase";
import { GetTypeModalityUseCase } from "../../../domain/usecases/consult/get-type-modality-usecase";
import { GetTypeResidentialAreaUseCase } from "../../../domain/usecases/consult/get-type-residential-area-usecase";
import { GetTypeIncomeUseCase } from "../../../domain/usecases/consult/get-type-income-usecase";
import { GetTypeUserUseCase } from "../../../domain/usecases/consult/get-type-user-usecase";
import { GetTypeModalityByIdUseCase } from "../../../domain/usecases/consult/get-type-modality-by-id-usecase";
import { GetTypeClasificationDiagnosticUseCase } from "../../../domain/usecases/consult/get-type-clasification-diagnostic.usecase";
import { GetRipsReportByDateUseCase } from "../../../domain/usecases/consult/get-rips-report-by-date.usecase";
import { GetAttentionAllStatesUseCase } from "../../../domain/usecases/consult/get-attention-all-states-usecase";
import { GetAttentionInProgressUseCase } from "../../../domain/usecases/consult/get-attention-in-progress-usecase";
import { GetLastAttentionUseCase } from "../../../domain/usecases/consult/get-last-attention-usecase";
import { GetElectrocardiogramRythmUseCase } from "../../../domain/usecases/consult/get-electrocardiogram-rythm-usecase";
import { GetElectrocardiogramWavesUseCase } from "../../../domain/usecases/consult/get-electrocardiogram-waves-usecase";
import { UpdateCardiovascularScreeningUseCase } from "../../../domain/usecases/consult/update-cardiovascular-screening.usecase";
import { InsertCardiovascularScreeningUseCase } from "../../../domain/usecases/consult/insert-cardiovascular-screening.usecase";
import { GetTypeFinalityUseCase } from "../../../domain/usecases/consult/get-type-finality-usecase";
import { GetTypeCauseUseCase } from "../../../domain/usecases/consult/get-type-cause.usecase";
import { GetViaEnterUseCase } from "../../../domain/usecases/consult/get-via-enter-usecase";
import { UpdateProcedureUseCase } from "../../../domain/usecases/consult/update-procedure-usecase";
import { InsertProcedureUseCase } from "../../../domain/usecases/consult/insert-procedure-usecase";
import { GetOriginUseCase } from "../../../domain/usecases/consult/get-origin.usecase";
import { GetExtensionUseCase } from "../../../domain/usecases/consult/get-extension.usecase";
import { UpdateInabilityUseCase } from "../../../domain/usecases/consult/update-inability.usecase";
import { InsertInabilityUseCase } from "../../../domain/usecases/consult/insert-inability-usecase";
import { InsertConsultOptometryUseCase } from "../../../domain/usecases/consult/insert-consult-optometry-usecase";
import { UpdateConsultOptometryUseCase } from "../../../domain/usecases/consult/update-consult-optometry-usecase";
import { UpdateBackgroundOptometryUseCase } from "../../../domain/usecases/consult/update-background-optometry-usecase";
import { InsertBackgroundOptometryUseCase } from "../../../domain/usecases/consult/insert-background-optometry-usecase";
import { GetTypeGlassesUseCase } from "../../../domain/usecases/consult/get-type-glasses-usecase";
import { GetTypeMaterialGlassesUseCase } from "../../../domain/usecases/consult/get-type-material-glasses-usecase";
import { GetTypeFilterGlassesUseCase } from "../../../domain/usecases/consult/get-type-filter-glasses-usecase";
import { UpdateLensiometryUseCase } from "../../../domain/usecases/consult/update-lensiometry-usecase";
import { InsertLensiometryUseCase } from "../../../domain/usecases/consult/insert-lensiometry-usecase";
import { InsertOftalmoscopyUseCase } from "../../../domain/usecases/consult/insert-oftalmoscopy-usecase";
import { UpdateOftalmoscopyUseCase } from "../../../domain/usecases/consult/update-oftalmoscopy-usecase";
import { GetDominantEyeUseCase } from "../../../domain/usecases/consult/get-dominant-eye.usecase";
import { UpdateVisualAcuityUseCase } from "../../../domain/usecases/consult/update-visual-acuity-usecase";
import { InsertVisualAcuityUseCase } from "../../../domain/usecases/consult/insert-visual-acuity.usecase";
import { InsertTestExternalUseCase } from "../../../domain/usecases/consult/insert-test-external-usecase";
import { UpdateTestExternalUseCase } from "../../../domain/usecases/consult/update-test-external.usecase";
import { InsertBiomicroscopyUseCase } from "../../../domain/usecases/consult/insert-biomicroscopy.usecase";
import { UpdateBiomicroscopyUseCase } from "../../../domain/usecases/consult/update-biomicroscopy.usecase";
import { UpdateSurfaceFilmUseCase } from "../../../domain/usecases/consult/update-surface-film.usecase";
import { InsertSurfaceFilmUseCase } from "../../../domain/usecases/consult/insert-surface-film.usecase";
import { InsertDeviationUseCase } from "../../../domain/usecases/consult/insert-deviation.usecase";
import { UpdateDeviationUseCase } from "../../../domain/usecases/consult/update-deviation.usecase";
import { GetTypeLookUseCase } from "../../../domain/usecases/consult/get-type-look-usecase";
import { InsertKerotometryUseCase } from "../../../domain/usecases/consult/insert-kerotometry.usecase";
import { UpdateKerotometryUseCase } from "../../../domain/usecases/consult/update-kerotometry.usecase";
import { GetTypeRetinoscopyUseCase } from "../../../domain/usecases/consult/get-type-retinoscopy-usecase";
import { UpdateRetinoscopyUseCase } from "../../../domain/usecases/consult/update-retinoscopy.usecase";
import { InsertRetinoscopyUseCase } from "../../../domain/usecases/consult/insert-retinoscopy-usecase";
import { UpdateTuningUseCase } from "../../../domain/usecases/consult/update-tuning.usecase";
import { UpdateSubjetiveUseCase } from "../../../domain/usecases/consult/update-subjetive.usecase";
import { InsertSubjetiveUseCase } from "../../../domain/usecases/consult/insert-subjetive-usecase";
import { UpdatePrescriptionUseCase } from "../../../domain/usecases/consult/update-prescription.usecase";
import { InsertTuningUseCase } from "../../../domain/usecases/consult/insert-tuning-usecase";
import { InsertPrescriptionUseCase } from "../../../domain/usecases/consult/insert-prescription-usecase";
import { GetVersionUseCase } from "../../../domain/usecases/consult/get-version.usecase";
import { GetKappaUseCase } from "../../../domain/usecases/consult/get-kappa.usecase";
import { InsertMotilityUseCase } from "../../../domain/usecases/consult/insert-motility-usecase";
import { UpdateMotilityUseCase } from "../../../domain/usecases/consult/update-motility.usecase";
import { UpdateOthersOptometryUseCase } from "../../../domain/usecases/consult/update-others-optometry-usecase";
import { InsertOthersUseCase } from "../../../domain/usecases/consult/insert-others-optometry-usecase";
import { GetTypeBirthUseCase } from "../../../domain/usecases/consult/get-type-birth.usecase";
import { InsertBackgroundNeuropsychologyUseCase } from "../../../domain/usecases/consult/insert-background-neuropsychology.usecase";
import { UpdateBackgroundNeuropsychologyUseCase } from "../../../domain/usecases/consult/update-background-neuropsychology.usecase";
import { InsertDevelopmentNeuropsychologyUseCase } from "../../../domain/usecases/consult/insert-development-neuropsychology.usecase";
import { InsertCompositionNeuropsychologyUseCase } from "../../../domain/usecases/consult/insert-composition-neuropsychology-usecase";
import { UpdateCompositionNeuropsychologyUseCase } from "../../../domain/usecases/consult/update-composition-neuropsychology-usecase";
import { UpdateDevelopmentNeuropsychologyUseCase } from "../../../domain/usecases/consult/update-development-neuropsychology-usecase";
import { DeleteRecordScholUseCase } from "../../../domain/usecases/consult/delete-record-schol.usecase";
import { DeleteFamilyCompositionUseCase } from "../../../domain/usecases/consult/delete-family-compositon.usecase";
import { InsertHistoryScholNeuropsychologyUseCase } from "../../../domain/usecases/consult/insert-history-schol-neuropsychology.usecase";
import { UpdateHistoryScholNeuropsychologyUseCase } from "../../../domain/usecases/consult/update-history-schol-neuropsychology-usecase";
import { InsertSpasmPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-spasm-physiotherapy-usecase";
import { UpdateSpasmPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-spasm-physiotherapy-usecase";
import { UpdateRehabilitationPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-rehabilitation-physiotherapy-usecase";
import { InsertRehabilitationPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-rehabilitation-physiotherapy-usecase";
import { GetAffectedAreaPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-affected-area-physiotherapy.usecase";
import { GetMuscleEvaluationPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-muscle-evaluation-physiotherapy.usecase";
import { InsertMuscleEvaluationPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-muscle-evaluation.usecase";
import { GetMembersPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-members-physiotherapy.usecase";
import { GetStateArcMotionPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-state-arc-motion-physiotherapy.usecase";
import { InsertArcMotionPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-arc-motion-physiotherapy.usecase";
import { DeleteArcMotionPhysiotherapyUseCase } from "../../../domain/usecases/consult/delete-arc-motion-physiotherapy.usecase";
import { DeleteMuscleEvaluationPhysiotherapyUseCase } from "../../../domain/usecases/consult/delete-muscle-evaluation-physiotherapy.usecase";
import { GetActivityDailyPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-activity-daily.usecase";
import { UpdatePainScalePhysiotherapyUseCase } from "../../../domain/usecases/consult/update-pain-scale-physiotherapy.usecase";
import { InsertPainScalePhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-pain-scale-physiotherapy.usecase";
import { GetListPainScalePhysiotherapyUseCase } from "../../../domain/usecases/consult/get-list-pain-scale-physiotherapy.usecase";
import { GetTypeHealthHabitPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-type-health-habit-physiotherapy.usecase";
import { UpdateHealthHabitPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-health-habit-physiotherapy-usecase";
import { InsertHealthHabitPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-health-habit-physiotherapy-usecase";
import { UpdateBackgroundPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-background-physiotherapy.usecase";
import { InsertBackgroundPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-background-physiotherapy.usecase";
import { UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-diagnostic-medical-rehability-physiotherapy-usecase";
import { InsertDiagnosticMedicalRehabilityPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-diagnostic-medical-rehability-physiotherapy-usecase";
import { GetTypeTransferPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-type-transfer-physiotherapy.usecase";
import { GetTypeScarPhysiotherapyUseCase } from "../../../domain/usecases/consult/get-type-scar-physiotherapy.usecase";
import { UpdateTransferPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-transfer-physiotherapy.usecase";
import { InsertTransferPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-transfer-physiotherapy.usecase";
import { InsertAnalysisMarchPhysiotherapyUseCase } from "../../../domain/usecases/consult/insert-analysis-match-physiotherapy.usecase";
import { UpdateAnalysisMarchPhysiotherapyUseCase } from "../../../domain/usecases/consult/update-analysis-march-physiotherapy.usecase";
import { GetStaticDinamicEquilibriumNeurologyUseCase } from "../../../domain/usecases/consult/get-static-dinamic-equilibrium-neurology.usecase";
import { GetHypotoniaNeurologyUseCase } from "../../../domain/usecases/consult/get-hypotonia-neurology.usecase";
import { GetSpasticityNeurologyUseCase } from "../../../domain/usecases/consult/get-spasticity-neurology.usecase";
import { GetPlanePostureNeurologyUseCase } from "../../../domain/usecases/consult/get-plane-posture-neurology.usecase";
import { UpdateExplorationNeurologyUseCase } from "../../../domain/usecases/consult/update-exploration-neurology-usecase";
import { InsertExplorationNeurologyUseCase } from "../../../domain/usecases/consult/insert-exploration-neurology-usecase";
// import { GenerateOtpConsentUseCase } from "../../../domain/usecases/consult/generate-otp-consent.usecase";
// import { ValidateOtpConsentUseCase } from "../../../domain/usecases/consult/validate-otp-consent.usecase";
import { DeleteConsentConsultUseCase } from "../../../domain/usecases/consult/delete-consent.usecase";
import { GetTypeAvailableDocumentUseCase } from "../../../domain/usecases/consult/get-available-document.usecase";
import { InsertFacturaTerceroUseCase } from "../../../domain/usecases/consult/insert-factura-tercero.usecase";
import { GetFacturaTerceroUseCase } from "../../../domain/usecases/consult/get-factura-tercero.usecase";
import { GetConsentByIdUseCase } from "../../../domain/usecases/consult/get-consent-by-id.usecase";
import { UpdateVitalSignsMedicalUseCase } from "../../../domain/usecases/consult/update-vital-signs-medical-usecase";
import { InsertVitalSignsMedicalUseCase } from "../../../domain/usecases/consult/insert-vital-signs-medical-usecase";
import { GetTypeStateTestFisicalUseCase } from "../../../domain/usecases/consult/get-type-state-test-fisical-usecase";
import { InsertTestFisicalUseCase } from "../../../domain/usecases/consult/insert-test-fisical-usecase";
import { UpdateTestFisicalUseCase } from "../../../domain/usecases/consult/update-test-fisical.usecase";
import { GetConsentPendientByIdUseCase } from "../../../domain/usecases/consult/get-consent-pendient-by-id.usecase";
import { SendConsentUseCase } from "../../../domain/usecases/consult/send-consent.usecase";
import { SignConsentUseCase } from "../../../domain/usecases/consult/sign-consent.usecase";
import { UpdateDevelopmentConsultOccupationalTherapyUseCase } from "../../../domain/usecases/consult/update-development-consult-occupational-therapy-usecase";
import { InsertDevelopmentConsultOccupationalTherapyUseCase } from "../../../domain/usecases/consult/insert-development-consult-occupational-therapy-usecase";
import { GetMedicationsUseCase } from '../../../domain/usecases/consult/get-medications.usecase';
import { GetDoseUseCase } from "../../../domain/usecases/consult/get-dose.usecase";
import { GetUnitsTimeUseCase } from "../../../domain/usecases/consult/get-units-time.usecase";
import { GetRoutesAdministrationUseCase } from "../../../domain/usecases/consult/get-routes-administration.usecase";
import { GetCalculatedFormulaUseCase } from "../../../domain/usecases/consult/get-calculated-formula.usecase";
import { GetTypeProcedureUseCase } from "../../../domain/usecases/consult/get-type-procedure.usecase";
import { GetProcedureNonSurgicalUseCase } from "../../../domain/usecases/consult/get-procedure-non-surgical.usecase";
import { InsertProcedureMedicationUseCase } from "../../../domain/usecases/consult/insert-procedure-medication-usecase";
import { UpdateProcedureMedicationUseCase } from "../../../domain/usecases/consult/update-procedure-medication-usecase";
import { InsertProcedureAtenttionUseCase } from "../../../domain/usecases/consult/insert-procedure-atenttion-usecase";
import { UpdateProcedureAtenttionUseCase } from "../../../domain/usecases/consult/update-procedure-atenttion-usecase";
import { GetAttentionByStepUseCase } from "../../../domain/usecases/consult/get-attention-by-step.usecase";
import { GetDataBasicAttentionUseCase } from "../../../domain/usecases/consult/get-data-basic-attention.usecase";
import { CreatePendingHCDListByIdUseCase } from "../../../domain/usecases/consult/create-Pending-HCD-List-By-Id.usecase";
import { CreateTeleconsultaUseCase } from "../../../domain/usecases/consult/create-teleconsulta.usecase";
import { ActivateTeleconsultaUseCase } from "../../../domain/usecases/consult/activate-teleconsulta.usecase";
import { GetTeleconsultaByIdUseCase } from "../../../domain/usecases/consult/get-teleconsulta-by-id.usecase";
import { GetAttentionReprocessListUseCase } from "../../../domain/usecases/consult/get-attention-reprocess-list.usecase";
import { ActivateDocumentReprocessUseCase } from "../../../domain/usecases/consult/activate-document-reprocess.usecase";
import { GetAttentionStateUseCase } from "../../../domain/usecases/consult/get-attention-state.usecase";

const getTypeDocumentsUseCaseFactory =
(typeDocuments: ConsultRepository) => new GetTypeDocumentsUseCase(typeDocuments);
export const GetTypeDocumentsUseCaseProvider = {
    provide: GetTypeDocumentsUseCase,
    useFactory: getTypeDocumentsUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeDiagnosticUseCaseFactory =
(typeDiagnostic: ConsultRepository) => new GetTypeDiagnosticUseCase(typeDiagnostic);
export const GetTypeDiagnosticUseCaseProvider = {
    provide: GetTypeDiagnosticUseCase,
    useFactory: getTypeDiagnosticUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeModalityUseCaseFactory =
(typeModality: ConsultRepository) => new GetTypeModalityUseCase(typeModality);
export const GetTypeModalityUseCaseProvider = {
    provide: GetTypeModalityUseCase,
    useFactory: getTypeModalityUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeModalityByIdUseCaseFactory =
(typeModality: ConsultRepository) => new GetTypeModalityByIdUseCase(typeModality);
export const GetTypeModalityByIdUseCaseProvider = {
    provide: GetTypeModalityByIdUseCase,
    useFactory: getTypeModalityByIdUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeFinalityUseCaseFactory =
(typeFinality: ConsultRepository) => new GetTypeFinalityUseCase(typeFinality);
export const GetTypeFinalityUseCaseProvider = {
    provide: GetTypeFinalityUseCase,
    useFactory: getTypeFinalityUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeIncomeUseCaseFactory =
(typeIncome: ConsultRepository) => new GetTypeIncomeUseCase(typeIncome);
export const GetTypeIncomeUseCaseProvider = {
    provide: GetTypeIncomeUseCase,
    useFactory: getTypeIncomeUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeStateTestFisicalUseCaseFactory =
(typeStateTestFisical: ConsultRepository) => new GetTypeStateTestFisicalUseCase(typeStateTestFisical);
export const GetTypeStateTestFisicalUseCaseProvider = {
    provide: GetTypeStateTestFisicalUseCase,
    useFactory: getTypeStateTestFisicalUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeClasificationDiagnosticUseCaseFactory =
(typeIncome: ConsultRepository) => new GetTypeClasificationDiagnosticUseCase(typeIncome);
export const GetTypeClasificationDiagnosticUseCaseProvider = {
    provide: GetTypeClasificationDiagnosticUseCase,
    useFactory: getTypeClasificationDiagnosticUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeResidentialAreaUseCaseFactory =
(typeResidential: ConsultRepository) => new GetTypeResidentialAreaUseCase(typeResidential);
export const GetTypeResidentialAreaUseCaseProvider = {
    provide: GetTypeResidentialAreaUseCase,
    useFactory: getTypeResidentialAreaUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionReportByDateUseCaseFactory =
(report: ConsultRepository) => new GetAttentionReportByDateUseCase(report);
export const GetAttentionReportByDateUseCaseProvider = {
    provide: GetAttentionReportByDateUseCase,
    useFactory: getAttentionReportByDateUseCaseFactory,
    deps: [ConsultRepository],
};

const getDetalleAtencionReportUseCaseFactory =
(report: ConsultRepository) => new GetDetalleAtencionReportUseCase(report);
export const GetDetalleAtencionReportUseCaseProvider = {
    provide: GetDetalleAtencionReportUseCase,
    useFactory: getDetalleAtencionReportUseCaseFactory,
    deps: [ConsultRepository],
};

const getRipsReportByDateUseCaseFactory =
(report: ConsultRepository) => new GetRipsReportByDateUseCase(report);
export const GetRipsReportByDateUseCaseProvider = {
    provide: GetRipsReportByDateUseCase,
    useFactory: getRipsReportByDateUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionConsecutiveUseCaseFactory =
(resumen: ConsultRepository) => new GetAttentionConsecutiveUseCase(resumen);
export const GetAttentionConsecutiveUseCaseProvider = {
    provide: GetAttentionConsecutiveUseCase,
    useFactory: getAttentionConsecutiveUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionByStepUseCaseFactory =
(resumen: ConsultRepository) => new GetAttentionByStepUseCase(resumen);
export const GetAttentionByStepUseCaseProvider = {
    provide: GetAttentionByStepUseCase,
    useFactory: getAttentionByStepUseCaseFactory,
    deps: [ConsultRepository],
};

const getDataBasicAttentionByIdUseCaseFactory =
(resumen: ConsultRepository) => new GetDataBasicAttentionUseCase(resumen);
export const GetDataBasicAttentionByIdUseCaseProvider = {
    provide: GetDataBasicAttentionUseCase,
    useFactory: getDataBasicAttentionByIdUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeConsultsUseCaseFactory =
(typeDocuments: ConsultRepository) => new GetTypeConsultUseCase(typeDocuments);
export const GetTypeConsultUseCaseProvider = {
    provide: GetTypeConsultUseCase,
    useFactory: getTypeConsultsUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeCauseUseCaseFactory =
(typeCause: ConsultRepository) => new GetTypeCauseUseCase(typeCause);
export const GetTypeCauseUseCaseProvider = {
    provide: GetTypeCauseUseCase,
    useFactory: getTypeCauseUseCaseFactory,
    deps: [ConsultRepository],
};


const getTypeUserUseCaseFactory =
(typeUser: ConsultRepository) => new GetTypeUserUseCase(typeUser);
export const GetTypeUserUseCaseProvider = {
    provide: GetTypeUserUseCase,
    useFactory: getTypeUserUseCaseFactory,
    deps: [ConsultRepository],
};

const getDocumentsByClientUseCaseFactory =
(Documents: ConsultRepository) => new GetDocumentsByClientUseCase(Documents);
export const GetDocumentsByClientUseCaseProvider = {
    provide: GetDocumentsByClientUseCase,
    useFactory: getDocumentsByClientUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionAllStatesUseCaseFactory =
(attention: ConsultRepository) => new GetAttentionAllStatesUseCase(attention);
export const GetAttentionAllStatesUseCaseProvider = {
    provide: GetAttentionAllStatesUseCase,
    useFactory: getAttentionAllStatesUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionProgressUseCaseFactory =
(attention: ConsultRepository) => new GetAttentionInProgressUseCase(attention);
export const GetAttentionInProgressUseCaseProvider = {
    provide: GetAttentionInProgressUseCase,
    useFactory: getAttentionProgressUseCaseFactory,
    deps: [ConsultRepository],
};

const getLastAttentionUseCaseFactory =
(attention: ConsultRepository) => new GetLastAttentionUseCase(attention);
export const GetLastAttentionUseCaseProvider = {
    provide: GetLastAttentionUseCase,
    useFactory: getLastAttentionUseCaseFactory,
    deps: [ConsultRepository],
};

const getStepServiceUseCaseFactory =
(step: ConsultRepository) => new GetStepServiceUseCase(step);
export const GetStepServiceUseCaseProvider = {
    provide: GetStepServiceUseCase,
    useFactory: getStepServiceUseCaseFactory,
    deps: [ConsultRepository],
}

const getElectrocardiogramRhythmServiceUseCaseFactory =
(electro: ConsultRepository) => new GetElectrocardiogramRythmUseCase(electro);
export const GetElectrocardiogramRythmUseCaseProvider = {
    provide: GetElectrocardiogramRythmUseCase,
    useFactory: getElectrocardiogramRhythmServiceUseCaseFactory,
    deps: [ConsultRepository],
}

const getElectrocardiogramWavesServiceUseCaseFactory =
(electro: ConsultRepository) => new GetElectrocardiogramWavesUseCase(electro);
export const GetElectrocardiogramWavesUseCaseProvider = {
    provide: GetElectrocardiogramWavesUseCase,
    useFactory: getElectrocardiogramWavesServiceUseCaseFactory,
    deps: [ConsultRepository],
}

const getViaEnterUseCaseFactory =
(via: ConsultRepository) => new GetViaEnterUseCase(via);
export const GetViaEnterUseCaseProvider = {
    provide: GetViaEnterUseCase,
    useFactory: getViaEnterUseCaseFactory,
    deps: [ConsultRepository],
}

const getOriginUseCaseFactory =
(origin: ConsultRepository) => new GetOriginUseCase(origin);
export const GetOriginUseCaseProvider = {
    provide: GetOriginUseCase,
    useFactory: getOriginUseCaseFactory,
    deps: [ConsultRepository],
}

const getExtensionUseCaseFactory =
(extension: ConsultRepository) => new GetExtensionUseCase(extension);
export const GetExtensionUseCaseProvider = {
    provide: GetExtensionUseCase,
    useFactory: getExtensionUseCaseFactory,
    deps: [ConsultRepository],
}

const getTypeLookUseCaseFactory =
(look: ConsultRepository) => new GetTypeLookUseCase(look);
export const GetTypeLookUseCaseProvider = {
    provide: GetTypeLookUseCase,
    useFactory: getTypeLookUseCaseFactory,
    deps: [ConsultRepository],
}

const getTypeGlassesUseCaseFactory =
(typeGlass: ConsultRepository) => new GetTypeGlassesUseCase(typeGlass);
export const GetTypeGlassesUseCaseProvider = {
    provide: GetTypeGlassesUseCase,
    useFactory: getTypeGlassesUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeMaterialGlassesUseCaseFactory =
(typeGlass: ConsultRepository) => new GetTypeMaterialGlassesUseCase(typeGlass);
export const GetTypeMaterialGlassesUseCaseProvider = {
    provide: GetTypeMaterialGlassesUseCase,
    useFactory: getTypeMaterialGlassesUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeFilterGlassesUseCaseFactory =
(typeGlass: ConsultRepository) => new GetTypeFilterGlassesUseCase(typeGlass);
export const GetTypeFilterGlassesUseCaseProvider = {
    provide: GetTypeFilterGlassesUseCase,
    useFactory: getTypeFilterGlassesUseCaseFactory,
    deps: [ConsultRepository],
};

const getDominantEyeUseCaseFactory =
(typeGlass: ConsultRepository) => new GetDominantEyeUseCase(typeGlass);
export const GetDominantEyeUseCaseProvider = {
    provide: GetDominantEyeUseCase,
    useFactory: getDominantEyeUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeRetinoscopyUseCaseFactory =
(typeGlass: ConsultRepository) => new GetTypeRetinoscopyUseCase(typeGlass);
export const GetTypeRetinoscopyUseCaseUseCaseProvider = {
    provide: GetTypeRetinoscopyUseCase,
    useFactory: getTypeRetinoscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const getVersionUseCaseFactory =
(version: ConsultRepository) => new GetVersionUseCase(version);
export const GetVersionUseCaseProvider = {
    provide: GetVersionUseCase,
    useFactory: getVersionUseCaseFactory,
    deps: [ConsultRepository],
};

const getKappaUseCaseFactory =
(version: ConsultRepository) => new GetKappaUseCase(version);
export const GetKappaUseCaseProvider = {
    provide: GetKappaUseCase,
    useFactory: getKappaUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeBirthUseCaseFactory =
(typeGlass: ConsultRepository) => new GetTypeBirthUseCase(typeGlass);
export const GetTypeBirthUseCaseProvider = {
    provide: GetTypeBirthUseCase,
    useFactory: getTypeBirthUseCaseFactory,
    deps: [ConsultRepository],
};

const getAffectedAreaPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetAffectedAreaPhysiotherapyUseCase(consult);
export const GetAffectedAreaPhysiotherapyUseCaseProvider = {
    provide: GetAffectedAreaPhysiotherapyUseCase,
    useFactory: getAffectedAreaPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getMembersPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetMembersPhysiotherapyUseCase(consult);
export const GetMembersPhysiotherapyUseCaseProvider = {
    provide: GetMembersPhysiotherapyUseCase,
    useFactory: getMembersPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getMucleEvaluationPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetMuscleEvaluationPhysiotherapyUseCase(consult);
export const GetMuscleEvaluationPhysiotherapyUseCaseProvider = {
    provide: GetMuscleEvaluationPhysiotherapyUseCase,
    useFactory: getMucleEvaluationPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getStateArcMotionPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetStateArcMotionPhysiotherapyUseCase(consult);
export const GetStateArcMotionPhysiotherapyUseCaseProvider = {
    provide: GetStateArcMotionPhysiotherapyUseCase,
    useFactory: getStateArcMotionPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getActivityDailyPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetActivityDailyPhysiotherapyUseCase(consult);
export const GetActivityDailyPhysiotherapyUseCaseProvider = {
    provide: GetActivityDailyPhysiotherapyUseCase,
    useFactory: getActivityDailyPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getListPainScalePhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetListPainScalePhysiotherapyUseCase(consult);
export const GetListPainScalePhysiotherapyUseCaseProvider = {
    provide: GetListPainScalePhysiotherapyUseCase,
    useFactory: getListPainScalePhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeHealthHabitPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetTypeHealthHabitPhysiotherapyUseCase(consult);
export const GetTypeHealthHabitPhysiotherapyUseCaseProvider = {
    provide: GetTypeHealthHabitPhysiotherapyUseCase,
    useFactory: getTypeHealthHabitPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeScarPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetTypeScarPhysiotherapyUseCase(consult);
export const GetTypeScarPhysiotherapyUseCaseProvider = {
    provide: GetTypeScarPhysiotherapyUseCase,
    useFactory: getTypeScarPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeTransferPhysiotherapyUseCaseFactory =
(consult: ConsultRepository) => new GetTypeTransferPhysiotherapyUseCase(consult);
export const GetTypeTransferPhysiotherapyUseCaseProvider = {
    provide: GetTypeTransferPhysiotherapyUseCase,
    useFactory: getTypeTransferPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const getSpasticityNeurologyUseCaseFactory =
(consult: ConsultRepository) => new GetSpasticityNeurologyUseCase(consult);
export const GetSpasticityNeurologyUseCaseProvider = {
    provide: GetSpasticityNeurologyUseCase,
    useFactory: getSpasticityNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const getHypotoniaNeurologyUseCaseFactory =
(consult: ConsultRepository) => new GetHypotoniaNeurologyUseCase(consult);
export const GetHypotoniaNeurologyUseCaseProvider = {
    provide: GetHypotoniaNeurologyUseCase,
    useFactory: getHypotoniaNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const getStaticDinamicEquilibriumNeurologyUseCaseFactory =
(consult: ConsultRepository) => new GetStaticDinamicEquilibriumNeurologyUseCase(consult);
export const GetStaticDinamicEquilibriumNeurologyUseCaseProvider = {
    provide: GetStaticDinamicEquilibriumNeurologyUseCase,
    useFactory: getStaticDinamicEquilibriumNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const getPlanePostureNeurologyUseCaseFactory =
(consult: ConsultRepository) => new GetPlanePostureNeurologyUseCase(consult);
export const GetPlanePostureNeurologyUseCaseProvider = {
    provide: GetPlanePostureNeurologyUseCase,
    useFactory: getPlanePostureNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeAvailableDocumentUseCaseFactory =
(typeDocument: ConsultRepository) => new GetTypeAvailableDocumentUseCase(typeDocument);
export const GetTypeAvailableDocumentUseCaseProvider = {
    provide: GetTypeAvailableDocumentUseCase,
    useFactory: getTypeAvailableDocumentUseCaseFactory,
    deps: [ConsultRepository],
};

const getConsentByIdUseCaseFactory =
(typeDocument: ConsultRepository) => new GetConsentByIdUseCase(typeDocument);
export const GetConsentByIdUseCaseProvider = {
    provide: GetConsentByIdUseCase,
    useFactory: getConsentByIdUseCaseFactory,
    deps: [ConsultRepository],
};

const getConsentPendientByIdUseCaseFactory =
(typeDocument: ConsultRepository) => new GetConsentPendientByIdUseCase(typeDocument);
export const GetConsentPendientByIdUseCaseProvider = {
    provide: GetConsentPendientByIdUseCase,
    useFactory: getConsentPendientByIdUseCaseFactory,
    deps: [ConsultRepository],
};

const getMedicationsUseCaseFactory =
(version: ConsultRepository) => new GetMedicationsUseCase(version);
export const GetMedicationUseCaseProvider = {
    provide: GetMedicationsUseCase,
    useFactory: getMedicationsUseCaseFactory,
    deps: [ConsultRepository],
};

const getDoseUseCaseFactory =
(version: ConsultRepository) => new GetDoseUseCase(version);
export const GetDoseUseCaseProvider = {
    provide: GetDoseUseCase,
    useFactory: getDoseUseCaseFactory,
    deps: [ConsultRepository],
};

const getUnitsTimeUseCaseFactory =
(version: ConsultRepository) => new GetUnitsTimeUseCase(version);
export const GetUnitsTimeUseCaseProvider = {
    provide: GetUnitsTimeUseCase,
    useFactory: getUnitsTimeUseCaseFactory,
    deps: [ConsultRepository],
};


const getRoutesAdministrationUseCaseFactory =
(version: ConsultRepository) => new GetRoutesAdministrationUseCase(version);
export const GetRoutesAdministrationUseCaseProvider = {
    provide: GetRoutesAdministrationUseCase,
    useFactory: getRoutesAdministrationUseCaseFactory,
    deps: [ConsultRepository],
};

const getCalculatedFormulaUseCaseFactory =
(version: ConsultRepository) => new GetCalculatedFormulaUseCase(version);
export const GetCalculatedFormulaUseCaseProvider = {
    provide: GetCalculatedFormulaUseCase,
    useFactory: getCalculatedFormulaUseCaseFactory,
    deps: [ConsultRepository],
};

const getTypeProcedureUseCaseFactory =
(version: ConsultRepository) => new GetTypeProcedureUseCase(version);
export const GetTypeProcedureUseCaseProvider = {
    provide: GetTypeProcedureUseCase,
    useFactory: getTypeProcedureUseCaseFactory,
    deps: [ConsultRepository],
};

const getProcedureNonSurgicalUseCaseFactory =
(version: ConsultRepository) => new GetProcedureNonSurgicalUseCase(version);
export const GetProcedureNonSurgicalUseCaseProvider = {
    provide: GetProcedureNonSurgicalUseCase,
    useFactory: getProcedureNonSurgicalUseCaseFactory,
    deps: [ConsultRepository],
};

const updateAttentionUseCaseFactory =
(attention: ConsultRepository) => new UpdateAttentionUseCase(attention);
export const UpdateAttentionUseCaseProvider = {
    provide: UpdateAttentionUseCase,
    useFactory: updateAttentionUseCaseFactory,
    deps: [ConsultRepository],
};

const insertProcedureMedicationUseCaseFactory =
(version: ConsultRepository) => new InsertProcedureMedicationUseCase(version);
export const InsertProcedureMedicationUseCaseProvider = {
    provide: InsertProcedureMedicationUseCase,
    useFactory: insertProcedureMedicationUseCaseFactory,
    deps: [ConsultRepository],
};

const updateGeneralUseCaseFactory =
(general: ConsultRepository) => new UpdateGeneralUseCase(general);
export const UpdateGeneralUseCaseProvider = {
    provide: UpdateGeneralUseCase,
    useFactory: updateGeneralUseCaseFactory,
    deps: [ConsultRepository],
};

const updateConsultUseCaseFactory =
(consult: ConsultRepository) => new UpdateConsultUseCase(consult);
export const UpdateConsultUseCaseProvider = {
    provide: UpdateConsultUseCase,
    useFactory: updateConsultUseCaseFactory,
    deps: [ConsultRepository],
};

const updateBackgroundUseCaseFactory =
(background: ConsultRepository) => new UpdateBackgroundUseCase(background);
export const UpdateBackgroundUseCaseProvider = {
    provide: UpdateBackgroundUseCase,
    useFactory: updateBackgroundUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDiagnosticUseCaseFactory =
(diagnostic: ConsultRepository) => new UpdateDiagnosticUseCase(diagnostic);
export const UpdateDiagnosticUseCaseProvider = {
    provide: UpdateDiagnosticUseCase,
    useFactory: updateDiagnosticUseCaseFactory,
    deps: [ConsultRepository],
};

const updateRevisionUseCaseFactory =
(diagnostic: ConsultRepository) => new UpdateRevisionUseCase(diagnostic);
export const UpdateRevisionUseCaseProvider = {
    provide: UpdateRevisionUseCase,
    useFactory: updateRevisionUseCaseFactory,
    deps: [ConsultRepository],
};

const updateVitalSignsUseCaseFactory =
(vital: ConsultRepository) => new UpdateVitalSignsUseCase(vital);
export const UpdateVitalSignsUseCaseProvider = {
    provide: UpdateVitalSignsUseCase,
    useFactory: updateVitalSignsUseCaseFactory,
    deps: [ConsultRepository],
};

const updateVitalSignMedicalUseCaseFactory =
(vital: ConsultRepository) => new UpdateVitalSignsMedicalUseCase(vital);
export const UpdateVitalSignsMedicalUseCaseProvider = {
    provide: UpdateVitalSignsMedicalUseCase,
    useFactory: updateVitalSignMedicalUseCaseFactory,
    deps: [ConsultRepository],
};

const updateOthersUseCaseFactory =
(other: ConsultRepository) => new UpdateOthersUseCase(other);
export const UpdateOthersUseCaseProvider = {
    provide: UpdateOthersUseCase,
    useFactory: updateOthersUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDocumentsUseCaseFactory =
(documents: ConsultRepository) => new UpdateDocumentsUseCase(documents);
export const UpdateDocumentsUseCaseProvider = {
    provide: UpdateDocumentsUseCase,
    useFactory: updateDocumentsUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDataInitialUseCaseFactory =
(data: ConsultRepository) => new UpdateDataInitialUseCase(data);
export const UpdateDataInitialUseCaseProvider = {
    provide: UpdateDataInitialUseCase,
    useFactory: updateDataInitialUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDevelopmentUseCaseFactory =
(development: ConsultRepository) => new UpdateDevelopmentUseCase(development);
export const UpdateDevelopmentUseCaseProvider = {
    provide: UpdateDevelopmentUseCase,
    useFactory: updateDevelopmentUseCaseFactory,
    deps: [ConsultRepository],
};

const updateCardiovascularScreeningUseCaseFactory =
(cardio: ConsultRepository) => new UpdateCardiovascularScreeningUseCase(cardio);
export const UpdateCardiovascularScreeningUseCaseProvider = {
    provide: UpdateCardiovascularScreeningUseCase,
    useFactory: updateCardiovascularScreeningUseCaseFactory,
    deps: [ConsultRepository],
};

const updateProcedureUseCaseFactory =
(procedure: ConsultRepository) => new UpdateProcedureUseCase(procedure);
export const UpdateProcedureUseCaseProvider = {
    provide: UpdateProcedureUseCase,
    useFactory: updateProcedureUseCaseFactory,
    deps: [ConsultRepository],
};

const updateInabilityUseCaseFactory =
(inability: ConsultRepository) => new UpdateInabilityUseCase(inability);
export const UpdateInabilityUseCaseProvider = {
    provide: UpdateInabilityUseCase,
    useFactory: updateInabilityUseCaseFactory,
    deps: [ConsultRepository],
};

const updateConsultOptometryUseCaseFactory =
(consult: ConsultRepository) => new UpdateConsultOptometryUseCase(consult);
export const UpdateConsultOptometryUseCaseProvider = {
    provide: UpdateConsultOptometryUseCase,
    useFactory: updateConsultOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const updateBackgroundOptometryUseCaseFactory =
(background: ConsultRepository) => new UpdateBackgroundOptometryUseCase(background);
export const UpdateBackgroundOptometryUseCaseProvider = {
    provide: UpdateBackgroundOptometryUseCase,
    useFactory: updateBackgroundOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const updateLensiometryUseCaseFactory =
(lensiometry: ConsultRepository) => new UpdateLensiometryUseCase(lensiometry);
export const UpdateLensiometryUseCaseProvider = {
    provide: UpdateLensiometryUseCase,
    useFactory: updateLensiometryUseCaseFactory,
    deps: [ConsultRepository],
};

const updateOftalmoscopyUseCaseFactory =
(oftal: ConsultRepository) => new UpdateOftalmoscopyUseCase(oftal);
export const UpdateOftalmoscopyUseCaseProvider = {
    provide: UpdateOftalmoscopyUseCase,
    useFactory: updateOftalmoscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateVisualAcuityUseCaseFactory =
(oftal: ConsultRepository) => new UpdateVisualAcuityUseCase(oftal);
export const UpdateVisualAcuityUseCaseProvider = {
    provide: UpdateVisualAcuityUseCase,
    useFactory: updateVisualAcuityUseCaseFactory,
    deps: [ConsultRepository],
};

const updateTestExternalUseCaseFactory =
(oftal: ConsultRepository) => new UpdateTestExternalUseCase(oftal);
export const UpdateTestExternalUseCaseProvider = {
    provide: UpdateTestExternalUseCase,
    useFactory: updateTestExternalUseCaseFactory,
    deps: [ConsultRepository],
};

const updateTestFisicalUseCaseFactory =
(test: ConsultRepository) => new UpdateTestFisicalUseCase(test);
export const UpdateTestFisicalUseCaseProvider = {
    provide: UpdateTestFisicalUseCase,
    useFactory: updateTestFisicalUseCaseFactory,
    deps: [ConsultRepository],
};

const updateBiomicroscopyUseCaseFactory =
(oftal: ConsultRepository) => new UpdateBiomicroscopyUseCase(oftal);
export const UpdateBiomicroscopyUseCaseProvider = {
    provide: UpdateBiomicroscopyUseCase,
    useFactory: updateBiomicroscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateSurfaceFilmUseCaseFactory =
(oftal: ConsultRepository) => new UpdateSurfaceFilmUseCase(oftal);
export const UpdateSurfaceFilmUseCaseProvider = {
    provide: UpdateSurfaceFilmUseCase,
    useFactory: updateSurfaceFilmUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDeviationUseCaseFactory =
(oftal: ConsultRepository) => new UpdateDeviationUseCase(oftal);
export const UpdateDeviationUseCaseProvider = {
    provide: UpdateDeviationUseCase,
    useFactory: updateDeviationUseCaseFactory,
    deps: [ConsultRepository],
};

const updateKerotometryUseCaseFactory =
(oftal: ConsultRepository) => new UpdateKerotometryUseCase(oftal);
export const UpdateKerotometryUseCaseProvider = {
    provide: UpdateKerotometryUseCase,
    useFactory: updateKerotometryUseCaseFactory,
    deps: [ConsultRepository],
};

const updateRetinoscopyUseCaseFactory =
(oftal: ConsultRepository) => new UpdateRetinoscopyUseCase(oftal);
export const UpdateRetinoscopyUseCaseProvider = {
    provide: UpdateRetinoscopyUseCase,
    useFactory: updateRetinoscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateSubjetiveUseCaseFactory =
(oftal: ConsultRepository) => new UpdateSubjetiveUseCase(oftal);
export const UpdateSubjetiveUseCaseProvider = {
    provide: UpdateSubjetiveUseCase,
    useFactory: updateSubjetiveUseCaseFactory,
    deps: [ConsultRepository],
};

const updateTuningUseCaseFactory =
(oftal: ConsultRepository) => new UpdateTuningUseCase(oftal);
export const UpdateTuningUseCaseProvider = {
    provide: UpdateTuningUseCase,
    useFactory: updateTuningUseCaseFactory,
    deps: [ConsultRepository],
};

const updatePrescriptionUseCaseFactory =
(oftal: ConsultRepository) => new UpdatePrescriptionUseCase(oftal);
export const UpdatePrescriptionUseCaseProvider = {
    provide: UpdatePrescriptionUseCase,
    useFactory: updatePrescriptionUseCaseFactory,
    deps: [ConsultRepository],
};

const updateMotilityUseCaseFactory =
(oftal: ConsultRepository) => new UpdateMotilityUseCase(oftal);
export const UpdateMotilityUseCaseProvider = {
    provide: UpdateMotilityUseCase,
    useFactory: updateMotilityUseCaseFactory,
    deps: [ConsultRepository],
};

const updateOthersOptometryUseCaseFactory =
(other: ConsultRepository) => new UpdateOthersOptometryUseCase(other);
export const UpdateOthersOptometryUseCaseProvider = {
    provide: UpdateOthersOptometryUseCase,
    useFactory: updateOthersOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const updateBackgroundNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new UpdateBackgroundNeuropsychologyUseCase(background);
export const UpdateBackgroundNeuropsychologyUseCaseProvider = {
    provide: UpdateBackgroundNeuropsychologyUseCase,
    useFactory: updateBackgroundNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDevelopmentNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new UpdateDevelopmentNeuropsychologyUseCase(background);
export const UpdateDevelopmentNeuropsychologyUseCaseProvider = {
    provide: UpdateDevelopmentNeuropsychologyUseCase,
    useFactory: updateDevelopmentNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDevelopmentConsultOccupationalTherapyUseCaseFactory =
(background: ConsultRepository) => new UpdateDevelopmentConsultOccupationalTherapyUseCase(background);
export const UpdateDevelopmentConsultOccupationalTherapyUseCaseProvider = {
    provide: UpdateDevelopmentConsultOccupationalTherapyUseCase,
    useFactory: updateDevelopmentConsultOccupationalTherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateCompositionNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new UpdateCompositionNeuropsychologyUseCase(background);
export const UpdateCompositionNeuropsychologyUseCaseProvider = {
    provide: UpdateCompositionNeuropsychologyUseCase,
    useFactory: updateCompositionNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateHistoryScholNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new UpdateHistoryScholNeuropsychologyUseCase(background);
export const UpdateHistoryScholNeuropsychologyUseCaseProvider = {
    provide: UpdateHistoryScholNeuropsychologyUseCase,
    useFactory: updateHistoryScholNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateSpasmPhysiotherapyUseCaseFactory =
(spasm: ConsultRepository) => new UpdateSpasmPhysiotherapyUseCase(spasm);
export const UpdateSpasmPhysiotherapyUseCaseProvider = {
    provide: UpdateSpasmPhysiotherapyUseCase,
    useFactory: updateSpasmPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateRehabilitationPhysiotherapyUseCaseFactory =
(spasm: ConsultRepository) => new UpdateRehabilitationPhysiotherapyUseCase(spasm);
export const UpdateRehabilitationPhysiotherapyUseCaseProvider = {
    provide: UpdateRehabilitationPhysiotherapyUseCase,
    useFactory: updateRehabilitationPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updatePainScalePhysiotherapyUseCaseFactory =
(spasm: ConsultRepository) => new UpdatePainScalePhysiotherapyUseCase(spasm);
export const UpdatePainScalePhysiotherapyUseCaseProvider = {
    provide: UpdatePainScalePhysiotherapyUseCase,
    useFactory: updatePainScalePhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateHealthHabitPhysiotherapyUseCaseFactory =
(spasm: ConsultRepository) => new UpdateHealthHabitPhysiotherapyUseCase(spasm);
export const UpdateHealthHabitPhysiotherapyUseCaseProvider = {
    provide: UpdateHealthHabitPhysiotherapyUseCase,
    useFactory: updateHealthHabitPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateBackgroundPhysiotherapyUseCaseFactory =
(background: ConsultRepository) => new UpdateBackgroundPhysiotherapyUseCase(background);
export const UpdateBackgroundPhysiotherapyUseCaseProvider = {
    provide: UpdateBackgroundPhysiotherapyUseCase,
    useFactory: updateBackgroundPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateDiagnosticMedicalRehabilityPhysiotherapyUseCaseFactory =
(diagnosty: ConsultRepository) => new UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCase(diagnosty);
export const UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider = {
    provide: UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCase,
    useFactory: updateDiagnosticMedicalRehabilityPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateTransferPhysiotherapyUseCaseFactory =
(transfer: ConsultRepository) => new UpdateTransferPhysiotherapyUseCase(transfer);
export const UpdateTransferPhysiotherapyUseCaseProvider = {
    provide: UpdateTransferPhysiotherapyUseCase,
    useFactory: updateTransferPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateAnalysisMarchPhysiotherapyUseCaseFactory =
(analysis: ConsultRepository) => new UpdateAnalysisMarchPhysiotherapyUseCase(analysis);
export const UpdateAnalysisMarchPhysiotherapyUseCaseProvider = {
    provide: UpdateAnalysisMarchPhysiotherapyUseCase,
    useFactory: updateAnalysisMarchPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateExplorationNeurologyUseCaseFactory =
(analysis: ConsultRepository) => new UpdateExplorationNeurologyUseCase(analysis);
export const UpdateExplorationNeurologyUseCaseProvider = {
    provide: UpdateExplorationNeurologyUseCase,
    useFactory: updateExplorationNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const updateProcedureMedicationUseCaseFactory =
(version: ConsultRepository) => new UpdateProcedureMedicationUseCase(version);
export const UpdateProcedureMedicationUseCaseProvider = {
    provide: UpdateProcedureMedicationUseCase,
    useFactory: updateProcedureMedicationUseCaseFactory,
    deps: [ConsultRepository],
};

const updateProcedureAtenttionUseCaseFactory =
(version: ConsultRepository) => new UpdateProcedureAtenttionUseCase(version);
export const UpdateProcedureAtenttionUseCaseProvider = {
    provide: UpdateProcedureAtenttionUseCase,
    useFactory: updateProcedureAtenttionUseCaseFactory,
    deps: [ConsultRepository],
};


const insertProcedureAtenttionUseCaseFactory =
(version: ConsultRepository) => new InsertProcedureAtenttionUseCase(version);
export const InsertProcedureAtenttionUseCaseProvider = {
    provide: InsertProcedureAtenttionUseCase,
    useFactory: insertProcedureAtenttionUseCaseFactory,
    deps: [ConsultRepository],
};


const insertConfirmationUseCaseFactory =
(confirmation: ConsultRepository) => new InsertConfirmationUseCase(confirmation);
export const InsertConfirmationUseCaseProvider = {
    provide: InsertConfirmationUseCase,
    useFactory: insertConfirmationUseCaseFactory,
    deps: [ConsultRepository],
};

const insertAttentionUseCaseFactory =
(attention: ConsultRepository) => new InsertAttentionUseCase(attention);
export const InsertAttentionUseCaseProvider = {
    provide: InsertAttentionUseCase,
    useFactory: insertAttentionUseCaseFactory,
    deps: [ConsultRepository],
};

const insertFacturaTerceroUseCaseFactory =
(facturaTercero: ConsultRepository) => new InsertFacturaTerceroUseCase(facturaTercero);
export const InsertFacturaTerceroUseCaseProvider = {
    provide: InsertFacturaTerceroUseCase,
    useFactory: insertFacturaTerceroUseCaseFactory,
    deps: [ConsultRepository],
};

const getFacturaTerceroUseCaseFactory =
(facturaTercero: ConsultRepository) => new GetFacturaTerceroUseCase(facturaTercero);
export const GetFacturaTerceroUseCaseProvider = {
    provide: GetFacturaTerceroUseCase,
    useFactory: getFacturaTerceroUseCaseFactory,
    deps: [ConsultRepository],
};

const insertGeneralUseCaseFactory =
(general: ConsultRepository) => new InsertGeneralUseCase(general);
export const InsertGeneralUseCaseProvider = {
    provide: InsertGeneralUseCase,
    useFactory: insertGeneralUseCaseFactory,
    deps: [ConsultRepository],
};

const insertConsultUseCaseFactory =
(consult: ConsultRepository) => new InsertConsultUseCase(consult);
export const InsertConsultUseCaseProvider = {
    provide: InsertConsultUseCase,
    useFactory: insertConsultUseCaseFactory,
    deps: [ConsultRepository],
};

const insertBackgroundUseCaseFactory =
(background: ConsultRepository) => new InsertBackgroundUseCase(background);
export const InsertBackgroundUseCaseProvider = {
    provide: InsertBackgroundUseCase,
    useFactory: insertBackgroundUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDiagnosticUseCaseFactory =
(diagnostic: ConsultRepository) => new InsertDiagnosticUseCase(diagnostic);
export const InsertDiagnosticUseCaseProvider = {
    provide: InsertDiagnosticUseCase,
    useFactory: insertDiagnosticUseCaseFactory,
    deps: [ConsultRepository],
};

const insertRevisionUseCaseFactory =
(diagnostic: ConsultRepository) => new InsertRevisionUseCase(diagnostic);
export const InsertRevisionUseCaseProvider = {
    provide: InsertRevisionUseCase,
    useFactory: insertRevisionUseCaseFactory,
    deps: [ConsultRepository],
};

const insertVitalSignsUseCaseFactory =
(vital: ConsultRepository) => new InsertVitalSignsUseCase(vital);
export const InsertVitalSignsUseCaseProvider = {
    provide: InsertVitalSignsUseCase,
    useFactory: insertVitalSignsUseCaseFactory,
    deps: [ConsultRepository],
};

const insertVitalSignsMedicalUseCaseFactory =
(vital: ConsultRepository) => new InsertVitalSignsMedicalUseCase(vital);
export const InsertVitalSignsMedicalUseCaseProvider = {
    provide: InsertVitalSignsMedicalUseCase,
    useFactory: insertVitalSignsMedicalUseCaseFactory,
    deps: [ConsultRepository],
};

const insertOthersUseCaseFactory =
(other: ConsultRepository) => new InsertOthersUseCase(other);
export const InsertOthersUseCaseProvider = {
    provide: InsertOthersUseCase,
    useFactory: insertOthersUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDocumentsUseCaseFactory =
(documents: ConsultRepository) => new InsertDocumentsUseCase(documents);
export const InsertDocumentsUseCaseProvider = {
    provide: InsertDocumentsUseCase,
    useFactory: insertDocumentsUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDataInitialUseCaseFactory =
(data: ConsultRepository) => new InsertDataInitialUseCase(data);
export const InsertDataInitialUseCaseProvider = {
    provide: InsertDataInitialUseCase,
    useFactory: insertDataInitialUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDevelopmentUseCaseFactory =
(development: ConsultRepository) => new InsertDevelopmentUseCase(development);
export const InsertDevelopmentUseCaseProvider = {
    provide: InsertDevelopmentUseCase,
    useFactory: insertDevelopmentUseCaseFactory,
    deps: [ConsultRepository],
};

const insertCardiovascularScreeningUseCaseFactory =
(cardio: ConsultRepository) => new InsertCardiovascularScreeningUseCase(cardio);
export const InsertCardiovascularScreeningUseCaseProvider = {
    provide: InsertCardiovascularScreeningUseCase,
    useFactory: insertCardiovascularScreeningUseCaseFactory,
    deps: [ConsultRepository],
};

const insertProcedureUseCaseFactory =
(procedure: ConsultRepository) => new InsertProcedureUseCase(procedure);
export const InsertProcedureUseCaseProvider = {
    provide: InsertProcedureUseCase,
    useFactory: insertProcedureUseCaseFactory,
    deps: [ConsultRepository],
}

const insertInabilityUseCaseFactory =
(inability: ConsultRepository) => new InsertInabilityUseCase(inability);
export const InsertInabilityUseCaseProvider = {
    provide: InsertInabilityUseCase,
    useFactory: insertInabilityUseCaseFactory,
    deps: [ConsultRepository],
};

const insertConsultOptometryUseCaseFactory =
(consult: ConsultRepository) => new InsertConsultOptometryUseCase(consult);
export const InsertConsultOptometryUseCaseProvider = {
    provide: InsertConsultOptometryUseCase,
    useFactory: insertConsultOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const insertBackgroundOptometryUseCaseFactory =
(background: ConsultRepository) => new InsertBackgroundOptometryUseCase(background);
export const InsertBackgroundOptometryUseCaseProvider = {
    provide: InsertBackgroundOptometryUseCase,
    useFactory: insertBackgroundOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const insertLensiometryUseCaseFactory =
(lensiometry: ConsultRepository) => new InsertLensiometryUseCase(lensiometry);
export const InsertLensiometryUseCaseProvider = {
    provide: InsertLensiometryUseCase,
    useFactory: insertLensiometryUseCaseFactory,
    deps: [ConsultRepository],
};

const insertOftalmoscopyUseCaseFactory =
(oftal: ConsultRepository) => new InsertOftalmoscopyUseCase(oftal);
export const InsertOftalmoscopyUseCaseProvider = {
    provide: InsertOftalmoscopyUseCase,
    useFactory: insertOftalmoscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertVisualAcuityUseCaseFactory =
(oftal: ConsultRepository) => new InsertVisualAcuityUseCase(oftal);
export const InsertVisualAcuityUseCaseProvider = {
    provide: InsertVisualAcuityUseCase,
    useFactory: insertVisualAcuityUseCaseFactory,
    deps: [ConsultRepository],
};

const insertTestExternalUseCaseFactory =
(oftal: ConsultRepository) => new InsertTestExternalUseCase(oftal);
export const InsertTestExternalUseCaseProvider = {
    provide: InsertTestExternalUseCase,
    useFactory: insertTestExternalUseCaseFactory,
    deps: [ConsultRepository],
};

const insertTestFisicalUseCaseFactory =
(test: ConsultRepository) => new InsertTestFisicalUseCase(test);
export const InsertTestFisicalUseCaseProvider = {
    provide: InsertTestFisicalUseCase,
    useFactory: insertTestFisicalUseCaseFactory,
    deps: [ConsultRepository],
};

const insertBiomicroscopyUseCaseFactory =
(oftal: ConsultRepository) => new InsertBiomicroscopyUseCase(oftal);
export const InsertBiomicroscopyUseCaseProvider = {
    provide: InsertBiomicroscopyUseCase,
    useFactory: insertBiomicroscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertSurfaceFilmUseCaseFactory =
(oftal: ConsultRepository) => new InsertSurfaceFilmUseCase(oftal);
export const InsertSurfaceFilmUseCaseProvider = {
    provide: InsertSurfaceFilmUseCase,
    useFactory: insertSurfaceFilmUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDeviationUseCaseFactory =
(oftal: ConsultRepository) => new InsertDeviationUseCase(oftal);
export const InsertDeviationUseCaseProvider = {
    provide: InsertDeviationUseCase,
    useFactory: insertDeviationUseCaseFactory,
    deps: [ConsultRepository],
};

const insertKerotometryUseCaseFactory =
(oftal: ConsultRepository) => new InsertKerotometryUseCase(oftal);
export const InsertKerotometryUseCaseProvider = {
    provide: InsertKerotometryUseCase,
    useFactory: insertKerotometryUseCaseFactory,
    deps: [ConsultRepository],
};

const insertRetinoscopyUseCaseFactory =
(oftal: ConsultRepository) => new InsertRetinoscopyUseCase(oftal);
export const InsertRetinoscopyUseCaseProvider = {
    provide: InsertRetinoscopyUseCase,
    useFactory: insertRetinoscopyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertSubjetiveUseCaseFactory =
(oftal: ConsultRepository) => new InsertSubjetiveUseCase(oftal);
export const InsertSubjetiveUseCaseProvider = {
    provide: InsertSubjetiveUseCase,
    useFactory: insertSubjetiveUseCaseFactory,
    deps: [ConsultRepository],
};

const insertTuningUseCaseFactory =
(oftal: ConsultRepository) => new InsertTuningUseCase(oftal);
export const InsertTuningUseCaseProvider = {
    provide: InsertTuningUseCase,
    useFactory: insertTuningUseCaseFactory,
    deps: [ConsultRepository],
};

const insertPrescriptionUseCaseFactory =
(oftal: ConsultRepository) => new InsertPrescriptionUseCase(oftal);
export const InsertPrescriptionUseCaseProvider = {
    provide: InsertPrescriptionUseCase,
    useFactory: insertPrescriptionUseCaseFactory,
    deps: [ConsultRepository],
};

const insertMotilityUseCaseFactory =
(oftal: ConsultRepository) => new InsertMotilityUseCase(oftal);
export const InsertMotilityUseCaseProvider = {
    provide: InsertMotilityUseCase,
    useFactory: insertMotilityUseCaseFactory,
    deps: [ConsultRepository],
};
const insertOthersOptometryUseCaseFactory =
(other: ConsultRepository) => new InsertOthersOptometryUseCase(other);
export const InsertOthersOptometryUseCaseProvider = {
    provide: InsertOthersOptometryUseCase,
    useFactory: insertOthersOptometryUseCaseFactory,
    deps: [ConsultRepository],
};

const insertBackgroundNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new InsertBackgroundNeuropsychologyUseCase(background);
export const InsertBackgroundNeuropsychologyUseCaseProvider = {
    provide: InsertBackgroundNeuropsychologyUseCase,
    useFactory: insertBackgroundNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDevelopmentNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new InsertDevelopmentNeuropsychologyUseCase(background);
export const InsertDevelopmentNeuropsychologyUseCaseProvider = {
    provide: InsertDevelopmentNeuropsychologyUseCase,
    useFactory: insertDevelopmentNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};


const insertCompositionNeuropsychologyUseCaseFactory =
(background: ConsultRepository) => new InsertCompositionNeuropsychologyUseCase(background);
export const InsertCompositionNeuropsychologyUseCaseProvider = {
    provide: InsertCompositionNeuropsychologyUseCase,
    useFactory: insertCompositionNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertHistoryScholNeuropsychologyUseCaseFactory =
(history: ConsultRepository) => new InsertHistoryScholNeuropsychologyUseCase(history);
export const InsertHistoryScholNeuropsychologyUseCaseProvider = {
    provide: InsertHistoryScholNeuropsychologyUseCase,
    useFactory: insertHistoryScholNeuropsychologyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertSpasmPhysiotherapyUseCaseFactory =
(spasm: ConsultRepository) => new InsertSpasmPhysiotherapyUseCase(spasm);
export const InsertSpasmPhysiotherapyUseCaseProvider = {
    provide: InsertSpasmPhysiotherapyUseCase,
    useFactory: insertSpasmPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertRehabilitationPhysiotherapyUseCaseFactory =
(rehab: ConsultRepository) => new InsertRehabilitationPhysiotherapyUseCase(rehab);
export const InsertRehabilitationPhysiotherapyUseCaseProvider = {
    provide: InsertRehabilitationPhysiotherapyUseCase,
    useFactory: insertRehabilitationPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertMuscleEvaluationPhysiotherapyUseCaseFactory =
(rehab: ConsultRepository) => new InsertMuscleEvaluationPhysiotherapyUseCase(rehab);
export const InsertMuscleEvaluationPhysiotherapyUseCaseProvider = {
    provide: InsertMuscleEvaluationPhysiotherapyUseCase,
    useFactory: insertMuscleEvaluationPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertArcMotionPhysiotherapyUseCaseFactory =
(rehab: ConsultRepository) => new InsertArcMotionPhysiotherapyUseCase(rehab);
export const InsertArcMotionPhysiotherapyUseCaseProvider = {
    provide: InsertArcMotionPhysiotherapyUseCase,
    useFactory: insertArcMotionPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertPainScalePhysiotherapyUseCaseFactory =
(rehab: ConsultRepository) => new InsertPainScalePhysiotherapyUseCase(rehab);
export const InsertPainScalePhysiotherapyUseCaseProvider = {
    provide: InsertPainScalePhysiotherapyUseCase,
    useFactory: insertPainScalePhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertHealthHabitPhysiotherapyUseCaseFactory =
(rehab: ConsultRepository) => new InsertHealthHabitPhysiotherapyUseCase(rehab);
export const InsertHealthHabitPhysiotherapyUseCaseProvider = {
    provide: InsertHealthHabitPhysiotherapyUseCase,
    useFactory: insertHealthHabitPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertBackgroundPhysiotherapyUseCaseFactory =
(background: ConsultRepository) => new InsertBackgroundPhysiotherapyUseCase(background);
export const InsertBackgroundPhysiotherapyUseCaseProvider = {
    provide: InsertBackgroundPhysiotherapyUseCase,
    useFactory: insertBackgroundPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDiagnosticMedicalRehabilityPhysiotherapyUseCaseFactory =
(diagnostic: ConsultRepository) => new InsertDiagnosticMedicalRehabilityPhysiotherapyUseCase(diagnostic);
export const InsertDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider = {
    provide: InsertDiagnosticMedicalRehabilityPhysiotherapyUseCase,
    useFactory: insertDiagnosticMedicalRehabilityPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertTransferPhysiotherapyUseCaseFactory =
(transfer: ConsultRepository) => new InsertTransferPhysiotherapyUseCase(transfer);
export const InsertTransferPhysiotherapyUseCaseProvider = {
    provide: InsertTransferPhysiotherapyUseCase,
    useFactory: insertTransferPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertAnalysisMarchPhysiotherapyUseCaseFactory =
(analysis: ConsultRepository) => new InsertAnalysisMarchPhysiotherapyUseCase(analysis);
export const InsertAnalysisMarchPhysiotherapyUseCaseProvider = {
    provide: InsertAnalysisMarchPhysiotherapyUseCase,
    useFactory: insertAnalysisMarchPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertExplorationNeurologyUseCaseFactory =
(analysis: ConsultRepository) => new InsertExplorationNeurologyUseCase(analysis);
export const InsertExplorationNeurologyUseCaseProvider = {
    provide: InsertExplorationNeurologyUseCase,
    useFactory: insertExplorationNeurologyUseCaseFactory,
    deps: [ConsultRepository],
};

const insertDevelopmentConsultOccupationalTherapyUseCaseFactory =
(analysis: ConsultRepository) => new InsertDevelopmentConsultOccupationalTherapyUseCase(analysis);
export const InsertDevelopmentConsultOccupationalTherapyUseCaseProvider = {
    provide: InsertDevelopmentConsultOccupationalTherapyUseCase,
    useFactory: insertDevelopmentConsultOccupationalTherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const cancelAttentionUseCaseFactory =
(cancel: ConsultRepository) => new CancelAttentionUseCase(cancel);
export const CancelAttentionUseCaseProvider = {
    provide: CancelAttentionUseCase,
    useFactory: cancelAttentionUseCaseFactory,
    deps: [ConsultRepository],
};

// const generateOTPConsentUseCaseFactory =
// (generate: ConsultRepository) => new GenerateOtpConsentUseCase(generate);
// export const GenerateOtpConsentUseCaseProvider = {
//     provide: GenerateOtpConsentUseCase,
//     useFactory: generateOTPConsentUseCaseFactory,
//     deps: [ConsultRepository],
// };

// const validateOTPConsentUseCaseFactory =
// (validate: ConsultRepository) => new ValidateOtpConsentUseCase(validate);
// export const ValidateOtpConsentUseCaseProvider = {
//     provide: ValidateOtpConsentUseCase,
//     useFactory: validateOTPConsentUseCaseFactory,
//     deps: [ConsultRepository],
// };

const sendConsentUseCaseFactory =
(generate: ConsultRepository) => new SendConsentUseCase(generate);
export const SendConsentUseCaseProvider = {
    provide: SendConsentUseCase,
    useFactory: sendConsentUseCaseFactory,
    deps: [ConsultRepository],
};

const signConsentUseCaseFactory =
(generate: ConsultRepository) => new SignConsentUseCase(generate);
export const SignConsentUseCaseProvider = {
    provide: SignConsentUseCase,
    useFactory: signConsentUseCaseFactory,
    deps: [ConsultRepository],
};


const deleteConsentUseCaseFactory =
(deleteCon: ConsultRepository) => new DeleteConsentConsultUseCase(deleteCon);
export const DeleteConsentConsultUseCaseProvider = {
    provide: DeleteConsentConsultUseCase,
    useFactory: deleteConsentUseCaseFactory,
    deps: [ConsultRepository],
};

const deleteDocumentUseCaseFactory =
(deleteDoc: ConsultRepository) => new DeleteDocumentUseCase(deleteDoc);
export const DeleteDocumentUseCaseProvider = {
    provide: DeleteDocumentUseCase,
    useFactory: deleteDocumentUseCaseFactory,
    deps: [ConsultRepository],
};

const deleteHistorySholUseCaseFactory =
(history: ConsultRepository) => new DeleteRecordScholUseCase(history);
export const DeleteRecordScholUseCaseProvider = {
    provide: DeleteRecordScholUseCase,
    useFactory: deleteHistorySholUseCaseFactory,
    deps: [ConsultRepository],
};

const deleteFamilyCompositionUseCaseFactory =
(family: ConsultRepository) => new DeleteFamilyCompositionUseCase(family);
export const DeleteFamilyCompositionUseCaseProvider = {
    provide: DeleteFamilyCompositionUseCase,
    useFactory: deleteFamilyCompositionUseCaseFactory,
    deps: [ConsultRepository],
};

const deleteMuscleEvaluationPhysiotherapyUseCaseFactory =
(family: ConsultRepository) => new DeleteMuscleEvaluationPhysiotherapyUseCase(family);
export const DeleteMuscleEvaluationPhysiotherapyUseCaseProvider = {
    provide: DeleteMuscleEvaluationPhysiotherapyUseCase,
    useFactory: deleteMuscleEvaluationPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};

const deleteArcMotionPhysiotherapyUseCaseFactory =
(family: ConsultRepository) => new DeleteArcMotionPhysiotherapyUseCase(family);
export const DeleteArcMotionPhysiotherapyUseCaseProvider = {
    provide: DeleteArcMotionPhysiotherapyUseCase,
    useFactory: deleteArcMotionPhysiotherapyUseCaseFactory,
    deps: [ConsultRepository],
};
/**HCD */

const createPendingHCDListByIdUseCaseFactory =
(idEmpresa: ConsultRepository) => new  CreatePendingHCDListByIdUseCase(idEmpresa);
export const CreatePendingHCDListByIdUseCaseProvider = {
    provide: CreatePendingHCDListByIdUseCase,
    useFactory: createPendingHCDListByIdUseCaseFactory,
    deps: [ConsultRepository],
};

/** Teleconsulta */
const createTeleconsultaUseCaseFactory =
(idAtencion: ConsultRepository) => new  CreateTeleconsultaUseCase(idAtencion);
export const CreateTeleconsultaUseCaseProvider = {
    provide: CreateTeleconsultaUseCase,
    useFactory: createTeleconsultaUseCaseFactory,
    deps: [ConsultRepository],
};
const activateTeleconsultaUseCaseFactory =
(idAtencion: ConsultRepository) => new  ActivateTeleconsultaUseCase(idAtencion);
export const ActivateTeleconsultaUseCaseProvider = {
    provide: ActivateTeleconsultaUseCase,
    useFactory: activateTeleconsultaUseCaseFactory,
    deps: [ConsultRepository],
};

const getTeleconsultaByIdUseCaseFactory =
(ClientRepo: ConsultRepository) => new GetTeleconsultaByIdUseCase(ClientRepo);

export const
GetTeleconsultaByIdUseCaseProvider = {
    provide: GetTeleconsultaByIdUseCase,
    useFactory: getTeleconsultaByIdUseCaseFactory,
    deps: [ConsultRepository],
};

const getAttentionStateUseCaseFactory =
  (states: ConsultRepository) => new  GetAttentionStateUseCase(states);
  export const GetAttentionStateUseCaseProvider = {
    provide: GetAttentionStateUseCase,
    useFactory: getAttentionStateUseCaseFactory,
    deps: [ConsultRepository],
};
/*Reproceso Documentos PDF*/
const getAttentionReprocessListUseCaseFactory =
(filters: ConsultRepository) => new  GetAttentionReprocessListUseCase(filters);
export const GetAttentionReprocessListUseCaseProvider = {
    provide: GetAttentionReprocessListUseCase,
    useFactory: getAttentionReprocessListUseCaseFactory,
    deps: [ConsultRepository],
};

const activateDocumentReprocessUseCaseFactory =
(params: ConsultRepository) => new  ActivateDocumentReprocessUseCase(params);
export const ActivateDocumentReprocessUseCaseProvider = {
    provide: ActivateDocumentReprocessUseCase,
    useFactory: activateDocumentReprocessUseCaseFactory,
    deps: [ConsultRepository],
};
